import productReducer from "./productReducer";

const salesReducers = {
    product: productReducer
}

export default salesReducers;